<template>
  <section class="dialog-welcome-container">
    <el-dialog v-model="welcome_guia" class="dialog-welcome p-0" header-class="header-dialog"
      body-class="container-welcome" :destroy-on-close="true" :show-close="false" align-center :width="anchoSidebar">
      <template #header>
        <h1 class="m-0 p-0 text-white title">¡Hola, {{ usuario.nombre }}!</h1>
        <strong class="sub-title">{{ usuario.genero == 1 ? 'Bienvenido' : 'Bienvenida' }} a mi Biografía</strong>
      </template>
      <p class="text-center fs-4 leyenda-inicial">
        El espacio donde tu historia toma forma de libro. <br>
        <strong class="text-primary">
          Ser Autor nunca fue tan fácil. Inicia con estos sencillos pasos.
        </strong>
        <br>
        Hoy empiezas un viaje para que tu historia viva por siempre.
      </p>

      <section class="opciones-pasos">
        <pasos-components />
      </section>

      <article class="w-100 text-center mt-2 welcome-media">
        <h3 class="title">
          Conoce cómo funciona
        </h3>
        <p>
          Mira este breve video para entender mejor el proceso
        </p>

        <content-video class="my-2" :url="url_video" :poster="Fotograma" />

      </article>

      <section class="d-flex justify-content-center mt-0 actions">
        <b-button variant="secondary" @click="cerrar">
          Ir a mi espacio de Creación
        </b-button>
      </section>

    </el-dialog>
  </section>

</template>

<script setup>
import Fotograma from '@images/medias/fotograma_1.png';
import useUsuarioStore from '@/store/usuario';
import useUtils from '@composables/useUtils';
import { ElAvatar } from 'element-plus';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { BBadge } from 'bootstrap-vue-next';

import ContentVideo from "views/public/components/ContentVideo.vue";

const usuario_store = useUsuarioStore();
const { anchoSidebar,loading } = useUtils();
const { welcome_guia,full_name,usuario } = storeToRefs(usuario_store);


const url_video = `${import.meta.env.VITE_API_URL}/storage/MIBiografiaOnBoarding.mp4`;
const pasos = ref([
  {
    paso:1,
    titulo:"Activa tus páginas",
    descripcion:"Ingresa un código, compra una biografía o adquiere páginas sueltas.",
    icono:'fas fa-file',
  },
  {
    paso: 2,
    titulo: "Cuéntanos tu historia",
    descripcion: "Compártenos tu historia en una entrevista personalizada",
    icono: 'fas fa-pencil',
  },
  {
    paso: 3,
    titulo: "Recibe tu libro",
    descripcion: "Nuestro escritor virtual creará tu historia en un libro impecable.",
    icono: 'fas fa-book-open',
  }
]);


const pasosComponents = () => pasos.value.map((paso) => {
  return h('article',{class:'paso d-flex flex-column align-items-center text-center  gap-50'},[
    h(ElAvatar, { size: 64, class:'avatars'}, {
      default: () => h(FontAwesomeIcon, { icon: paso.icono, size: '2x', color:'black' })
    }),
    h(BBadge,{ class:'text-black badges'},{
      default: () =>  `Paso ${paso.paso}`
    }),
    h('h3',{class:'title-paso'}, paso.titulo),
    h('p',{class:'descripcion-paso lh-1 fs-5 text-primary'}, paso.descripcion)
  ])
})

const cerrar = () => {
  welcome_guia.value = false;
}

</script>

<style lang="scss" scoped>
@use "@variables/variables" as *;



  .dialog-welcome-container{

  

    :deep(.header-dialog) {
      background-image:url('@images/pages/header-welcome-guia.png');
      border-radius: 5px 5px 0 0;
      height:250px;
      background-position: bottom center;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      position:relative;

      &:before{
        content:'';
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background-color: rgba(0, 0, 0, 0.3);
      }

      .title{
        font-size:44pt;
        font-family:"JosefinSans-Bold";
        z-index:1;
        color:white;
      }

      .sub-title{
        font-size:18pt;
        font-family: "JosefinSans-Regular";
        z-index:1;
        color:white;

      }


    }

    :deep(.container-welcome){
      padding:2rem;
      min-height:300px;
      max-height: 70vh;
      overflow-y: scroll;
      display:flex;
      flex-direction: column;

      .leyenda-inicial{
        font-family: "JosefinSans-Regular";
        color:$dark;
        margin-top:.5rem;
        strong{
          font-family: "JosefinSans-Bold";
        }
      }

      .opciones-pasos{
        display:flex;
        flex-direction: column;
        justify-content: center;
        gap:1rem;


        @media (min-width:768px){
          flex-direction: row;
          flex-wrap:wrap;
        }

        .paso{
          flex:1 1 30%;
          padding:1rem;
          border: 2px solid $secondary;
          border-radius: 10px;
          background-color: rgba(108, 117, 125, 0.1);
          min-width: 250px;

          .el-avatar{
            background-color: #eac44f !important;
              border: 2px solid $secondary;
          }
          

          .badges{
            font-family: "JosefinSans-Bold";
            font-size:14pt;
            padding:0.5rem 1rem;
            border-radius: 20px;
            background-color: #eac44f !important;
            border: 2px solid $secondary;
          }

          .title-paso{
            font-family: "JosefinSans-Bold";
            font-size:18pt;
            margin-top:0.5rem;
            color:$dark;
          }

          .descripcion-paso{
            font-family: "JosefinSans-Regular";
            // margin-top:0.5rem;
          }
        }
      }

      .welcome-media{
        .title{
          font-family: "JosefinSans-Bold";
          font-size:24pt;
          color:$dark;
        }
        p{
          font-family: "JosefinSans-Regular";
          font-size:16pt;
          color:$gris;
        }
      }

      .actions{
        button{
          font-family: "JosefinSans-Bold";
          font-size:16pt;
          padding:0.5rem 2rem;
          border-radius: 30px;
        }
      }

    }
    
  }


 


</style>